export class SrcsetParser {
    static parse($img) {
        const srcsetStr = $img.srcset
        if (!srcsetStr) {
            console.warn('image', $img, 'has no `srcset` attribute available.')
            return [{
                url: $img.src,
                conditionDescriptor: `${$img.naturalWidth}w`
            }]
        }
        
        const srcsetArr = srcsetStr.split(',').map(_imageCandidateString => {
            const [url, conditionDescriptor] = _imageCandidateString.trim().split(' ')
            
            return {url, conditionDescriptor}
        })
        return srcsetArr
    }
    static getResolutions($img, aspectRatio) {
        const srcsetArr = this.parse($img)
        const hydrated = srcsetArr.map(_entry => {
            const width = parseInt( _entry.conditionDescriptor.slice(0, -1) )
            const height = Math.ceil(width / aspectRatio)
            return {
                url: _entry.url,
                width,
                height
            }
        })
        const sorted = hydrated.toSorted((a, b) => a.width - b.width)
        return sorted
    }
}